import React from 'react';
import { Mail, Phone } from 'lucide-react';

const TopBar = () => {
  return (
    <div className="w-full bg-[#0B2E46] border-b border-white/5 py-3 md:py-2 px-4 md:px-8 flex flex-col md:flex-row justify-between items-center z-[100] relative gap-3 md:gap-0">
      {/* Updated section: removed span and unified styling */}
      <div className="text-[13px] md:text-[14px] text-center md:text-left text-white font-semibold font-serif">
        Legal and Compliance as a Service
      </div>
      
      <div className="flex flex-col sm:flex-row gap-6 sm:gap-10 items-center">
        <a href="mailto:anshoo@lcaas.in" className="flex items-center gap-2 text-[14px] md:text-[15px] font-bold text-white hover:text-[#78BE20] transition-colors">
          <Mail size={16} className="text-[#78BE20]" />
          anshoo@lcaas.in
        </a>
        <a href="tel:+919810476281" className="flex items-center gap-2 text-[14px] md:text-[15px] font-bold text-white hover:text-[#78BE20] transition-colors">
          <Phone size={16} className="text-[#78BE20]" />
          +91-98104-76281
        </a>
      </div>
    </div>
  );
};

export default TopBar;